// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__2hp-X","col":"styles_col__vi1SQ"};